var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "table mt-0 table-sm table-hover" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.drugs, function (d, i) {
          return _c("tr", [
            _c("td", [_vm._v(_vm._s(i + 1))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(d.drug_id))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(d.title))]),
            _vm._v(" "),
            _c("td", [_vm._v(_vm._s(d.egk_id))]),
            _vm._v(" "),
            _c(
              "td",
              _vm._l(d.disabled_projects, function (p, i) {
                return _c("span", [
                  _vm._v(
                    _vm._s((i !== 0 ? ", " : "") + _vm.$AllProjects[p].title)
                  ),
                ])
              }),
              0
            ),
            _vm._v(" "),
            _c("td"),
          ])
        }),
        0
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("ID")]),
        _vm._v(" "),
        _c("th", [_vm._v("препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("егк")]),
        _vm._v(" "),
        _c("th", [_vm._v("проекты")]),
        _vm._v(" "),
        _c("th"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }